const sizes = {
  "2xs": "1rem",
  // 16px
  xs: "1.5rem",
  // 24px
  sm: "2rem",
  // 32px
  md: "2.5rem",
  // 40px
  lg: "3rem",
  // 48px
  xl: "3.5rem",
  // 56px
  "2xl": "4rem"
  // 64px
};

export { sizes };
